import {Component} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {InvoiceOption} from './invoice-option.enum';
import {NgForOf} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {CheckboxModule} from '@primeng/checkbox';

@Component({
  selector: 'app-confirm-invoice-type',
  standalone: true,
  templateUrl: './confirm-invoice-type.component.html',
  imports: [
    NgForOf,
    FormsModule,
    TranslatePipe,
    CheckboxModule
  ],
  styleUrl: './confirm-invoice-type.component.scss'
})
export class ConfirmInvoiceTypeComponent {
  InvoiceOption = InvoiceOption;

  types = [
    { id: InvoiceOption.RENT, label: 'METER.RENT' },
    { id: InvoiceOption.HEATING, label: 'METER.HEATING' },
    { id: InvoiceOption.COLD_WATER, label: 'METER.COLD_WATER' },
    { id: InvoiceOption.WARM_WATER, label: 'METER.WARM_WATER' },
  ];

  selectedOptions: InvoiceOption[] = [];
  get allSelected(): boolean {
    return this.types.every(t => this.selectedOptions.includes(t.id));
  }

  set allSelected(value: boolean) {
    this.selectedOptions = value ? this.types.map(t => t.id) : [];
  }

  constructor(public activeModal: NgbActiveModal) {}

  isDisabled(): boolean {
    return this.selectedOptions.length === 0;
  }

  confirm() {
    this.activeModal.close({
      confirmed: true,
      selectedOptions: this.selectedOptions
    });
  }

  cancel() {
    this.activeModal.dismiss();
  }
}
